/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface IProspectServiceClient {
        saveProspect: (ITaapProspectView) => ng.IPromise<any>;
        userHasProspect: () => ng.IPromise<any>;
        getUncSchools: () => ng.IPromise<any>;
        getTaapProfile: () => ng.IPromise<any>;
    }
    
    export class ProspectServiceClient implements IProspectServiceClient {
        static $inject: string[] = ["Restangular", "common", "$http"];

        constructor(private Restangular: Restangular.IService, private common: ICommonFactory, private $http: ng.IHttpService) {
        }

        saveProspect(taapProspectView: ITaapProspectView) {

            var deferred = this.common.$q.defer();

            if (taapProspectView.AdditionalData.deniedAdmission && !taapProspectView.AdditionalData.acceptedToUncInstitution)
                taapProspectView.AdditionalData.eligible = true;
            else
                taapProspectView.AdditionalData.eligible = false;

            this.Restangular.all("Prospect/insertprospecttaap").post(taapProspectView).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
                });

            return deferred.promise;
        }

        userHasProspect() {
            var deferred = this.common.$q.defer();
            this.Restangular.one("Prospect/isProspectSubmitted").get().then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
                });
            return deferred.promise;
        }

        getUncSchools() {
            var deferred = this.common.$q.defer();
            this.Restangular.all("institutions/getUncSchools").getList().then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
                });
            return deferred.promise;
        }

        getTaapProfile() {
            var deferred = this.common.$q.defer();
            this.Restangular.one("Prospect/getTaapProfile").get().then((data) => {
                deferred.resolve(data);
            }, (reason) => {
                deferred.reject(reason);
                });
            return deferred.promise;
        }
    }

    angular.module("app").service("prospectServiceClient", ProspectServiceClient);
}